import React, { useState } from "react";
import { addDoc, collection } from "firebase/firestore";
import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
} from "react-share";
import { db } from "../../services/firebase";

const Waitlist = () => {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateEmail = (email: string) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setIsValid(validateEmail(newEmail) || newEmail === "");
    setIsSubmitted(false);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validateEmail(email)) {
      try {
        setIsSubmitting(true);

        const docRef = await addDoc(collection(db, "waitlistEmails"), {
          email: email,
          timestamp: new Date(),
        });

        console.log("Email added with ID: ", docRef.id);

        setEmail("");
        setIsSubmitted(true);
      } catch (error) {
        console.error("Error adding email: ", error);
        alert("An error occurred. Please try again.");
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setIsValid(false);
    }
  };

  const shareUrl = "https://haircare-ai.web.app/"; // Replace with your actual website URL
  const shareTitle =
    "I just joined the waitlist for Haircare AI! Check it out:";

  return (
    <div>
      <div className="z-40">
        {isSubmitted ? (
          <div className="text-center">
            <div className="text-green-500 font-semibold py-2">Received!</div>
            <div>
              <p className="mb-2">Share with your friends:</p>
              <div className="flex justify-center space-x-4">
                <FacebookShareButton url={shareUrl} hashtag={shareTitle}>
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
                <TwitterShareButton url={shareUrl} title={shareTitle}>
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
              </div>
            </div>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-row items-center justify-center space-x-2"
          >
            <div>
              <input
                className={`border w-full md:w-[300px] py-[10px] px-4 rounded-xl ${
                  isValid ? "border-gray-300" : "border-red-500"
                }`}
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                type="email"
              />
            </div>
            <div>
              <button
                type="submit"
                className="flex hover:cursor-pointer justify-center w-[100px] lg:w-[120px] items-center rounded-xl border-2 border-gray-950 bg-[#0A0A0A] px-2 md:px-6 py-[10px]"
                disabled={isSubmitting}
              >
                <h1 className="text-[14px] text-white font-semibold">
                  {isSubmitting ? "Submitting..." : "Notify me"}
                </h1>
              </button>
            </div>
          </form>
        )}
        {!isValid && !isSubmitted && (
          <p className="text-red-500 text-sm mt-1">
            Please enter a valid email address
          </p>
        )}
      </div>
    </div>
  );
};

export default Waitlist;
